import React from 'react';
import styled from 'styled-components';

import Icon from '@ey/motif-react-wrapper/Icon';
import {IconoirInfoCircle} from '@ey-xd/motif-icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../../../../../../CoreWrappers/Button';

const prop = 'actions';

export default (labels, tab) => ({
	id: `${prop}Column`,
	label: labels[prop],
	propName: prop,
	width: 'var(--px-160)',
	customCell: ({riskId}) => {
		const props = {
			label: tab.actionColumnButtonLabel,
			title: tab.actionColumnButtonLabel,
			variant: 'text-alt',
			onClick: () => tab.action(riskId)
		};

		return <StyledButton {...props} />;
	},
	customHeaderCell: () => (
		<StyledHeader>
			<OutputText body2 ellipsis title={labels[prop]}>
				{labels[prop]}
			</OutputText>
			<Icon src={IconoirInfoCircle} title={tab.actionColumnHeaderTitletip} />
		</StyledHeader>
	)
});

const StyledHeader = styled.div`
	display: flex;
	gap: inherit;
	min-width: 0;
	.motif-icon {
		flex-shrink: 0;
	}
`;

const StyledButton = styled(Button)`
	min-width: 0;
`;
